module.exports = __webpack_public_path__ + "img/agri-waterfert.9ab14595.jpg";